import { useGameStore } from "../store/useGameStore.js";
import { useCardSet } from "../contexts/CardSetContext.js";
import { pendingFlipFaceUrls } from "../lib/dragState.js";

// ============================================================
// StockPile — Nachziehstapel
// ============================================================

export function StockPile() {
  const { gameState, drawStock } = useGameStore();
  const { getBackUrl, getFaceUrl } = useCardSet();

  const stockCount = gameState.stock.length;
  const topStockCard = stockCount > 0 ? gameState.stock[stockCount - 1] : undefined;
  const backUrl = getBackUrl();

  function handleClick() {
    // Flip-URL für die Fly-Animation setzen (Rückseite → Vorderseite)
    if (topStockCard) {
      pendingFlipFaceUrls.set(topStockCard.id, getFaceUrl(topStockCard));
    }
    drawStock();
  }

  return (
    <div
      className="relative w-full cursor-pointer"
      style={{ aspectRatio: "2/3" }}
      onClick={handleClick}
      role="button"
      aria-label={
        stockCount > 0
          ? `Nachziehstapel (${stockCount} Karten)`
          : "Stapel umdrehen"
      }
    >
      {stockCount > 0 ? (
        <div data-card-id={topStockCard!.id} className="relative w-full h-full">
          <img
            src={backUrl}
            alt="Nachziehstapel"
            className="w-full h-full object-fill rounded-md block pointer-events-none"
            draggable={false}
          />
          <span className="absolute bottom-0.5 right-1 text-[20px] font-bold text-white/70 leading-none pointer-events-none">
            {stockCount}
          </span>
        </div>
      ) : (
        <div className="absolute inset-0 rounded-md border-2 border-white/25 flex items-center justify-center">
          <span className="text-white/40 text-3xl leading-none">↺</span>
        </div>
      )}
    </div>
  );
}
